const specials = [
  {
    id: 'kappa-biriyani',
    title: 'Kappa Biriyani',
    day: 'Fri – Sun',
    tag: 'Weekend Special',
    description: 'Tapioca and meat slow-cooked the Kuttanad way. Earthy, peppery, and unforgettable.',
    accent: '#A0241F'
  },
  {
    id: 'pothichoru',
    title: 'Pothichoru',
    day: 'Saturday',
    tag: 'Banana-Leaf Meal',
    description: 'Banana-leaf parcels of rice, fish curry, beef ularthiyathu, and pickle. Untie and feast.',
    accent: '#2F7D3A'
  },
  {
    id: 'kizhi-porotta',
    title: 'Kizhi Porotta',
    day: 'Saturday',
    tag: 'Steamed in Banana Leaf',
    description: 'Layered porotta steamed in a banana-leaf bundle with spiced chicken. Open at the table.',
    accent: '#E08E2A'
  },
  {
    id: 'butter-chicken',
    title: 'Butter Chicken',
    day: 'Sunday',
    tag: 'Sunday Special',
    description: 'Tender chicken in a velvety tomato-butter gravy. Call ahead, it goes fast.',
    accent: '#D4A24C'
  }
];

export default specials;
